import { GamificationStatus } from '@/@types/gamification';

export const CAMPAIGN_STATUS_VALUES = Object.values(GamificationStatus);

export const BackendStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SCHEDULED: 'SCHEDULED',
  FINISHED: 'FINISHED',
  DRAFT: 'DRAFT',
} as const;

export type BackendStatus = (typeof BackendStatus)[keyof typeof BackendStatus];

export const BACKEND_STATUS_VALUES = Object.values(BackendStatus);

export const FilterStatus = {
  ALL: 'ALL',
  NONE: '',
} as const;

export type FilterStatus = (typeof FilterStatus)[keyof typeof FilterStatus];

export const FILTER_STATUS_VALUES = Object.values(FilterStatus);

export type AllowedStatusValue =
  | GamificationStatus
  | BackendStatus
  | FilterStatus;

export const ALL_STATUS_VALUES: readonly (string | GamificationStatus)[] = [
  ...CAMPAIGN_STATUS_VALUES,
  ...BACKEND_STATUS_VALUES,
  ...FILTER_STATUS_VALUES,
] as const;
